enum FunctionsDialogFields {
	ADDWATERMARK = "addWatermark",
	CHANGEDOCUMENTSETTINGS = "changeDocumentSettings",
	CHANGEDOCUMENTVIEW = "changeDocumentView",
	COMPRESS = "compress",
	CONVERTDOCUMENT = "convertDocument",
	CREATEBARCODE = "createBarcode",
	DELETEPAGES = "deletePages",
	DETECTBARCODE = "detectBarcode",
	EDITANNOTATION = "editAnnotation",
	EDITATTACHMENT = "editAttachment",
	EDITBACKGROUND = "editBackground",
	EDITBOXES = "editBoxes",
	EDITFORMS = "editForms",
	EDITHEADERFOOTER = "editHeaderFooter",
	EDITTRANSITIONS = "editTransitions",
	ENCRYPTDOCUMENT = "encryptDocument",
	EXPORTASIMAGE = "exportAsImage",
	EXTRACTCONTENT = "extractContent",
	EXTRACTPAGES = "extractPages",
	MERGEDOCUMENT = "mergeDocument",
	MOVEPAGES = "movePages",
	OCRCONVERSION = "ocrConversion",
	OUTLINE = "outline",
	PDFACONVERSION = "pdfaConversion",
	PORTFOLIO = "portfolio",
	PRINTDOCUMENT = "printDocument",
	REDACT = "redact",
	RENAMEDOCUMENT = "renameDocument",
	ROTATEPAGES = "rotatePages",
	SANITIZE = "sanitize",
	SCALEPAGES = "scalePages",
	SHOWHELP = "showHelp",
	SIGNDOCUMENT = "signDocument",
	SPLITDOCUMENT = "splitDocument",
	UPLOADFILE = "uploadFile",
	UPLOADURL = "uploadUrl",
	TRANSCRIBE = "transcribe",
	DISPLAY_DISKSPACE = "display_diskspace",
	DISPLAY_MAXFILES = "display_maxFiles"
}

export default FunctionsDialogFields;